import { readonly, ref, ssrRef, shallowReadonly } from '@nuxtjs/composition-api'
import { UseRelatedProductsInterface, UseRelatedProductsSearch, UseRelatedProductsSearchParams } from './useRelatedProducts'
import { useApi } from '~/composables'
import { Logger } from '~/helpers/logger'
import { getProductSeries as getProductSeriesMutation } from '~/modules/catalog/aatrium/graphql/getProductSeries'
import { Product } from '~/modules/catalog/product/types'

export function useRelatedProducts (sku: string | number, count: number = 15): UseRelatedProductsInterface {
  const { query } = useApi()
  const loading = ref<boolean>(false)
  const error = ref<string | null>(null)
  const relatedProducts = ssrRef<Product[]>([], `related-products-${sku}`)

  async function search (params?: UseRelatedProductsSearchParams): Promise<void> {
    const skuLocal = params?.sku || sku
    const countLocal = params?.count || count

    try {
      loading.value = true
      Logger.debug('[Magento] Load related products based on ', { params })

      const { data } = await query<UseRelatedProductsSearch>(getProductSeriesMutation, { sku: skuLocal, count: countLocal })

      if (data?.getProductSeries) {
        relatedProducts.value = data.getProductSeries?.items || []
      }

      Logger.debug('[Result]:', { data })
      error.value = null
    } catch (err) {
      error.value = err
      Logger.error('useRelatedProducts/search', err)
    } finally {
      loading.value = false
    }
  }

  return {
    error: readonly(error),
    loading: readonly(loading),
    relatedProducts: shallowReadonly(relatedProducts),
    search
  }
}
